import { createApi } from "@reduxjs/toolkit/query/react";

import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
// import { mapImporterFormResponse } from "@/redux/mappers/MasterMapper/MasterMapper";

export const highSeaSellerApi = createApi({
  reducerPath: "highSeaSellerApi",
  baseQuery,
  tagTypes: ["HighSeaSellerApi"],
  endpoints: (builder) => ({
    getHighSeaSeller: builder.query({
      query: ({ id }) => `/import/HighSeaSeller/${id}`,
      transformResponse: (response) => {
        const mapped = response?.data;
        return mapped;
      },
      providesTags: (result, error, id) => [{ type: "HighSeaSellerApi", id }],
    }),
    createHighSeaSeller: builder.mutation({
      query: ({id,...data}) => ({
        url: `/import/HighSeaSeller/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: {highSeaSeller : data},
      }),
      invalidatesTags: ["HighSeaSellerApi"],
    }),

     updateHighSeaSeller: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/import/HighSeaSeller/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { highSeaSeller: data }, 

      }),
      invalidatesTags: ["HighSeaSellerApi"],
    }),

    // 🔄 DELETE entity
    deleteHighSeaSeller: builder.mutation({
      query: ({ id }) => ({
        url: `/import/HighSeaSeller/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["HighSeaSellerApi"],
    }),


    // updateImporter: builder.mutation({
    //   query: ({ id, ...data }) => ({
    //     url: `/import/general/${id}`, // append id in URL
    //     method: "PUT",
    //     headers: {
    //       "X-Request-Id": Math.random().toString(36).substring(2),
    //     },
    //     body: data,
    //   }),
    //   invalidatesTags: ["Importer"],
    // }),
  }),
});

export const {useGetHighSeaSellerQuery, useUpdateHighSeaSellerMutation, useCreateHighSeaSellerMutation,useDeleteHighSeaSellerMutation } = highSeaSellerApi;

